export const removeCategoryButtonLabel = "Reb";
export const searchCategoryButtonLabel = "Seb";
export default {removeCategoryButtonLabel,searchCategoryButtonLabel};